import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, Star } from "lucide-react";
import Seo from "@/lib/Seo";
import { api, mediaUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Avis() {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    api.get("/public/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  return (
    <>
      <Seo title="Avis" path="/avis"
        description="Les avis des familles et supporters qui jouent à Douzième Homme — Le Jeu, Édition Nice." />
      <section className="py-14 sm:py-20" data-testid="avis-page">
        <div className="container-x">
          <Reveal className="max-w-3xl mb-12">
            <p className="eyebrow mb-4">Avis</p>
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight uppercase leading-[1.05] text-onyx">
              Ils ont adopté le jeu.
            </h1>
            <p className="mt-5 text-base sm:text-lg text-muted-foreground">
              Les retours des familles niçoises et des supporters autour du plateau.
            </p>
          </Reveal>

          {reviews === null ? (
            <p className="text-muted-foreground">Chargement…</p>
          ) : reviews.length === 0 ? (
            <div className="bg-white border border-line p-10 text-center max-w-xl" data-testid="avis-empty">
              <Quote className="w-8 h-8 text-rouge mx-auto mb-4" />
              <p className="font-display font-bold text-onyx text-lg">Les premiers avis arrivent bientôt.</p>
              <p className="text-sm text-muted-foreground mt-2">
                Vous avez le jeu ? <Link to="/contact" className="text-rouge font-semibold hover:underline">Écrivez-nous</Link> pour partager votre expérience.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="avis-grid">
              {reviews.map((r, i) => (
                <Reveal key={r.id} delay={i * 0.05}>
                  <figure className={`h-full p-8 border ${r.featured ? "bg-onyx text-cream border-onyx" : "bg-white border-line"}`} data-testid={`avis-card-${i}`}>
                    <Quote className={`w-6 h-6 mb-4 ${r.featured ? "text-rouge-light" : "text-rouge"}`} />
                    <blockquote className={`text-sm sm:text-base leading-relaxed ${r.featured ? "text-cream/85" : "text-muted-foreground"}`}>
                      {r.text}
                    </blockquote>
                    <figcaption className="mt-6 flex items-center gap-3">
                      {r.photo && <img src={mediaUrl(r.photo)} alt={r.author} className="w-10 h-10 rounded-full object-cover" loading="lazy" />}
                      <div>
                        <p className={`font-display font-bold text-sm ${r.featured ? "text-cream" : "text-onyx"}`}>{r.author}</p>
                        {r.role && <p className={`text-xs ${r.featured ? "text-cream/55" : "text-muted-foreground"}`}>{r.role}</p>}
                      </div>
                      {r.rating && (
                        <span className="ml-auto flex gap-0.5" aria-label={`${r.rating} sur 5`}>
                          {Array.from({ length: r.rating }).map((_, s) => (
                            <Star key={s} className="w-3.5 h-3.5 fill-gold text-gold" />
                          ))}
                        </span>
                      )}
                    </figcaption>
                  </figure>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
